export type Education = {
  school: string;
  degree: string;
  meta: string;
};

export const education: Education[] = [
  {
    school: 'Carroll University',
    degree: 'B.S. Actuarial Science (Applied Statistics)',
    meta: 'Waukesha, WI · Dec 2014',
  },
];
